import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function Modal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  if (!type) return null;
  const isPrivacy = type === 'privacy';
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-17">
      <div className="relative bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-18">
        {/* Header */}
        <div className="sticky top-0 bg-slate-900 border-b border-slate-800 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-19">
          <h2 className="text-xl font-bold text-white" data-id="element-20">
            {isPrivacy ? 'Política de Privacidad' : 'Términos y Condiciones'}
          </h2>
          <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-slate-800" data-id="element-21">
            <X className="w-5 h-5" data-id="element-22" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 text-slate-300 text-sm leading-relaxed space-y-4" data-id="element-23">
          {isPrivacy ? <>
              <p className="text-slate-400 text-xs" data-id="element-24">
                Última actualización: {new Date().getFullYear()}
              </p>
              <p data-id="element-25">
                En <strong className="text-white" data-id="element-26">El Reset de los 30+</strong>,
                respetamos tu privacidad y nos comprometemos a proteger tu
                información personal.
              </p>
              <h3 className="text-white font-bold text-base mt-4" data-id="element-27">
                Información que recopilamos
              </h3>
              <p data-id="element-28">
                Recopilamos únicamente la información necesaria para procesar tu
                compra y entregarte el producto digital: nombre, correo
                electrónico e información de pago (procesada de forma segura por
                terceros).
              </p>
              <h3 className="text-white font-bold text-base mt-4" data-id="element-29">
                Uso de la información
              </h3>
              <p data-id="element-30">
                Tu información se utiliza exclusivamente para: entregar el
                producto adquirido, enviarte actualizaciones del producto y
                comunicaciones relacionadas con tu compra.
              </p>
              <h3 className="text-white font-bold text-base mt-4" data-id="element-31">Seguridad</h3>
              <p data-id="element-32">
                Utilizamos encriptación SSL y procesadores de pago certificados.
                No almacenamos datos de tarjetas de crédito en nuestros
                servidores.
              </p>
              <h3 className="text-white font-bold text-base mt-4" data-id="element-33">Cookies</h3>
              <p data-id="element-34">
                Este sitio puede utilizar cookies para mejorar la experiencia
                del usuario y analizar el tráfico. Puedes desactivarlas en la
                configuración de tu navegador.
              </p>
              <h3 className="text-white font-bold text-base mt-4" data-id="element-35">Terceros</h3>
              <p data-id="element-36">
                No vendemos, alquilamos ni compartimos tu información personal
                con terceros con fines comerciales.
              </p>
            </> : <>
              <p className="text-slate-400 text-xs" data-id="element-37">
                Última actualización: {new Date().getFullYear()}
              </p>
              <p data-id="element-38">
                Al adquirir{' '}
                <strong className="text-white" data-id="element-39">El Reset de los 30+</strong>,
                aceptas los siguientes términos y condiciones.
              </p>
              <h3 className="text-white font-bold text-base mt-4" data-id="element-40">
                Producto digital
              </h3>
              <p data-id="element-41">
                Este es un producto de descarga digital. Una vez completada la
                compra, recibirás acceso inmediato al contenido. Por la
                naturaleza del producto, no se aceptan devoluciones salvo lo
                indicado en nuestra garantía.
              </p>
              <h3 className="text-white font-bold text-base mt-4" data-id="element-42">
                Garantía de 30 días
              </h3>
              <p data-id="element-43">
                Ofrecemos una garantía de satisfacción de 30 días. Si no estás
                satisfecho con el producto, contáctanos dentro de los 30 días
                posteriores a la compra para gestionar tu reembolso.
              </p>
              <h3 className="text-white font-bold text-base mt-4" data-id="element-44">
                Uso del contenido
              </h3>
              <p data-id="element-45">
                El contenido de este producto es para uso personal únicamente.
                Queda prohibida la reproducción, distribución o reventa total o
                parcial del material sin autorización expresa.
              </p>
              <h3 className="text-white font-bold text-base mt-4" data-id="element-46">
                Resultados
              </h3>
              <p data-id="element-47">
                Los resultados mencionados en esta página son ejemplos y no
                garantizan resultados idénticos. Los resultados individuales
                varían según el esfuerzo, experiencia y circunstancias de cada
                persona.
              </p>
              <h3 className="text-white font-bold text-base mt-4" data-id="element-48">
                Modificaciones
              </h3>
              <p data-id="element-49">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. Los cambios entrarán en vigor al publicarse
                en esta página.
              </p>
            </>}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-10 px-4 text-center border-t border-slate-900 bg-slate-950" data-id="element-50">
        {/* Disclaimer */}
        <p className="text-slate-500 text-xs max-w-md mx-auto mb-5 leading-relaxed" data-id="element-51">
          ⚠️{' '}
          <em data-id="element-52">
            No es terapia clínica. Es un protocolo para recuperar ambición y
            enfoque. Úsalo bajo tu propio riesgo.
          </em>
        </p>

        <p className="text-slate-500 text-sm mb-3" data-id="element-53">
          © {new Date().getFullYear()} El Reset de los 30+. Todos los derechos
          reservados.
        </p>

        <div className="flex items-center justify-center gap-6" data-id="element-54">
          <button onClick={() => setActiveModal('privacy')} className="text-slate-500 hover:text-teal-400 text-xs transition-colors underline underline-offset-2" data-id="element-55">
            Política de Privacidad
          </button>
          <span className="text-slate-700" data-id="element-56">·</span>
          <button onClick={() => setActiveModal('terms')} className="text-slate-500 hover:text-teal-400 text-xs transition-colors underline underline-offset-2" data-id="element-57">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <Modal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-58" />
    </>;
}